
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Mumbaitooutstationcab() {



    const cardData =
    {
        keyword: 'Mumbai to Outstation Cab',
        heading: 'S9 Travels: Mumbai to Outstation Cab',
        headingDescription: 'S9 Travels offers reliable and comfortable Mumbai to Outstation Cab services, ensuring a hassle-free journey for all your travel needs. Whether you are planning a weekend getaway, a family vacation, or a business trip, our fleet of well-maintained cabs is ready to take you to your destination. Enjoy a smooth and safe ride with our professional drivers who are committed to providing timely and efficient services. With spacious interiors, luxury features, and flexible booking options, S9 Travels ensures your journey from Mumbai to any outstation is as comfortable and convenient as possible.',


        top: 'Top Places to Visit in Near Mumbai with S9 Travels',

"topPlaces": [
    {
      "title": "Lonavala",
      "description": "A popular hill station near Mumbai, Lonavala is known for its lush greenery, waterfalls, and caves. Key attractions include Tiger’s Leap, Bhushi Dam, Rajmachi Fort, and the ancient Karla and Bhaja Caves."
    },
    {
      "title": "Khandala",
      "description": "Situated close to Lonavala, Khandala is famous for its stunning viewpoints like Duke’s Nose and Sunset Point. The misty hills and serene valleys make it a perfect weekend getaway from Mumbai."
    },
    {
      "title": "Alibaug",
      "description": "A coastal town known for its pristine beaches and historic forts, Alibaug is a favorite destination for beach lovers. Must-visit places include Alibaug Beach, Kashid Beach, Murud-Janjira Fort, and Kolaba Fort."
    },
    {
      "title": "Matheran",
      "description": "India’s smallest hill station, Matheran is a vehicle-free zone, offering breathtaking views and fresh air. Attractions include Panorama Point, Charlotte Lake, Echo Point, and the famous toy train ride."
    },
    {
      "title": "Mahabaleshwar",
      "description": "A scenic hill station known for its strawberry farms, Mahabaleshwar is home to stunning viewpoints like Arthur’s Seat, Wilson Point, and Venna Lake. It's a great place to unwind amidst nature."
    },
    {
      "title": "Pawna Lake",
      "description": "A picturesque lake near Lonavala, Pawna Lake is a popular camping destination. Surrounded by the forts of Lohagad, Tung, and Tikona, it’s an ideal spot for adventure lovers."
    },
    {
      "title": "Karnala Bird Sanctuary",
      "description": "Located near Panvel, this bird sanctuary is a paradise for bird watchers and nature lovers. The Karnala Fort within the sanctuary offers a scenic trekking experience."
    },
    {
      "title": "Igatpuri",
      "description": "Nestled in the Sahyadri Hills, Igatpuri is famous for its lush green landscapes, waterfalls, and the Vipassana International Academy. Popular attractions include Bhatsa River Valley, Tringalwadi Fort, and Kalsubai Peak."
    },
    {
      "title": "Bhandardara",
      "description": "A serene getaway known for its waterfalls, lakes, and lush greenery, Bhandardara is home to Arthur Lake, Randha Falls, and the historic Ratangad Fort."
    },
    {
      "title": "Kolad",
      "description": "Famous for white-water rafting on the Kundalika River, Kolad is an adventure enthusiast's paradise. The scenic surroundings and waterfalls add to its charm."
    }
],

"services": [
  {
    "name": "Mumbai to Outstation Cab Service",
    "description": "S9 Travels offers reliable Mumbai to outstation cab services, ensuring safe, comfortable, and convenient travel to destinations across India. Whether you're planning a quick weekend getaway or a long-distance journey, our outstation cabs provide the perfect transportation solution."
  },
  {
    "name": "Book Mumbai to Outstation Taxi",
    "description": "Booking a taxi for your outstation trip from Mumbai is easy with S9 Travels. Whether you're planning a one-way or round-trip journey, we offer a variety of taxi options to meet your needs. Our professional chauffeurs ensure a safe and comfortable ride to your destination."
  },
  {
    "name": "Affordable Mumbai Outstation Cab Service",
    "description": "S9 Travels offers affordable Mumbai outstation cab services without compromising on comfort and quality. Whether you're looking for a budget-friendly ride or a luxurious travel experience, we have the right options to suit your needs, making your outstation travel cost-effective."
  },
  {
    "name": "Private Taxi for Outstation Trips from Mumbai",
    "description": "Travel in comfort and privacy with our private taxi service for outstation trips from Mumbai. S9 Travels offers dedicated taxi services for individuals or families, allowing you to travel at your own pace and enjoy a personalized experience on your journey."
  },
  {
    "name": "Mumbai to Outstation One-Way or Round Trip",
    "description": "S9 Travels offers one-way and round-trip outstation cab services from Mumbai, providing flexible travel options. Whether you're traveling to a nearby city or a distant destination, our services are tailored to make your journey easy and hassle-free, with competitive pricing and a reliable travel experience."
  },
  {
    "name": "Luxury Cab for Outstation Travel from Mumbai",
    "description": "Travel in style with our luxury cab service for outstation travel from Mumbai. S9 Travels offers high-end vehicles equipped with premium amenities, perfect for those who want a touch of elegance and comfort during their journey to outstation destinations."
  },
  {
    "name": "Comfortable Outstation Travel by Taxi from Mumbai",
    "description": "S9 Travels ensures comfortable outstation travel by taxi from Mumbai. Our well-maintained vehicles and professional drivers provide a smooth and relaxing ride, whether you're heading to a nearby city or a more distant destination. Enjoy a comfortable and stress-free journey with us."
  },
  {
    "name": "Mumbai to Outstation Sightseeing Tours",
    "description": "Explore outstation destinations with S9 Travels' sightseeing tours from Mumbai. Our taxis are perfect for group or solo tours, taking you to popular tourist spots and hidden gems across the region. With experienced drivers and well-maintained cars, your sightseeing journey will be enjoyable and informative."
  },
  {
    "name": "Group Travel to Outstation Destinations from Mumbai",
    "description": "S9 Travels offers group travel services for outstation trips from Mumbai, ensuring that your group travels together in comfort and style. Whether you're planning a family reunion, corporate retreat, or friends' getaway, we provide spacious vehicles that can accommodate large groups while ensuring a safe and enjoyable trip."
  }
],

"tableData": [
  ["Mumbai to Outstation Cab Service", "Book Mumbai to Outstation Taxi"],
  ["Affordable Mumbai Outstation Cab Service", "Private Taxi for Outstation Trips from Mumbai"],
  ["Mumbai to Outstation One-Way or Round Trip", "Luxury Cab for Outstation Travel from Mumbai"],
  ["Comfortable Outstation Travel by Taxi from Mumbai", "Mumbai to Outstation Sightseeing Tours"],
  ["Group Travel to Outstation Destinations from Mumbai", ""],
  ["", ""]
],





"whychoose": [
  {
    "WhyChooseheading": "Comfortable and Reliable Long-Distance Travel",
    "WhyChoosedescription": "S9 Travels offers a comfortable Mumbai to outstation cab service, ideal for long-distance journeys. Our fleet of well-maintained vehicles, including the Toyota Innova and other premium cars, ensures a smooth, comfortable ride with ample space, air conditioning, and plush seating, making your trip enjoyable no matter the distance."
  },
  {
    "WhyChooseheading": "Timely and Dependable Service",
    "WhyChoosedescription": "We understand that timely travel is essential. Our Mumbai to outstation cab service ensures punctual pick-ups and drop-offs, so you can reach your destination on time without any delays. Whether you're traveling for business, leisure, or a special event, we guarantee reliable service every time."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our experienced drivers are familiar with the best routes and road conditions for outstation trips from Mumbai. They prioritize safety, comfort, and efficiency, ensuring your journey is smooth and pleasant, no matter the destination."
  },
  {
    "WhyChooseheading": "Affordable and Transparent Pricing",
    "WhyChoosedescription": "S9 Travels offers affordable rates for Mumbai to outstation cab services. We provide a transparent pricing structure with no hidden charges. You’ll receive a clear breakdown of the cost during the booking process, allowing you to plan your travel budget without surprises."
  },
  {
    "WhyChooseheading": "Safety and Comfort on Your Outstation Journey",
    "WhyChoosedescription": "Your safety is our top priority. All our vehicles are equipped with modern safety features like GPS tracking, airbags, and seat belts to ensure a safe and comfortable journey for you and your passengers throughout your outstation trip from Mumbai."
  },
  {
    "WhyChooseheading": "24/7 Availability for Flexible Scheduling",
    "WhyChoosedescription": "S9 Travels operates 24/7, offering flexible scheduling for your outstation trips. Whether you need an early morning departure or a late-night return, we’re here to provide reliable service that fits your travel schedule."
  },
  {
    "WhyChooseheading": "Customizable Itineraries for Your Outstation Trip",
    "WhyChoosedescription": "We understand that every trip is unique. Whether you need to make stops along the way, have specific locations to visit, or require special arrangements, we offer customizable itineraries to suit your preferences and make your outstation journey even more enjoyable."
  },
  {
    "WhyChooseheading": "Simple and Hassle-Free Booking",
    "WhyChoosedescription": "Booking your Mumbai to outstation cab with S9 Travels is simple and hassle-free. You can easily book your ride online through our website or mobile app, or contact our customer service team for personalized assistance. We strive to make your booking process quick, easy, and convenient."
  }
]










    }

    const faqData = [
        [
          {
            question: 'How can I book an outstation cab from Mumbai?',
            answer: 'Booking an outstation cab from Mumbai is easy! You can book your ride via our website, mobile app, or by contacting our customer service team for personalized assistance. We’ll ensure a comfortable and hassle-free journey to your destination.',
          },
          {
            question: 'What types of vehicles are available for outstation trips from Mumbai?',
            answer: 'We offer a range of vehicles for outstation trips from Mumbai, including sedans, SUVs, and premium vehicles like the Toyota Innova. Choose the vehicle that best suits your group size and travel preferences.',
          },
          {
            question: 'Are the drivers experienced for outstation trips from Mumbai?',
            answer: 'Yes, our drivers are highly experienced in handling outstation trips from Mumbai. They are familiar with the best routes and ensure your safety and comfort during the journey.',
          },
          {
            question: 'Can I book a round-trip cab for outstation travel from Mumbai?',
            answer: 'Yes, you can book a round-trip cab for outstation travel from Mumbai. Simply provide us with your return details, and we will ensure a smooth and timely return journey.',
          },
          {
            question: 'How long in advance should I book an outstation cab from Mumbai?',
            answer: 'We recommend booking your outstation cab at least 1-2 days in advance to ensure vehicle availability and secure your preferred travel time. However, last-minute bookings can also be accommodated based on availability.',
          },
          {
            question: 'Is there a fixed fare for outstation cab services from Mumbai?',
            answer: 'The fare for outstation trips from Mumbai depends on the distance, type of vehicle, and specific requirements. Contact us for a customized quote, and we’ll provide you with transparent pricing based on your trip details.',
          },
          {
            question: 'Do you offer pick-up services from Mumbai airport or hotels for outstation trips?',
            answer: 'Yes, we provide convenient pick-up services from Mumbai airport or hotels for your outstation journey. Our drivers will ensure a smooth transfer to your destination.',
          },
          {
            question: 'Can I request additional stops on the way during an outstation trip from Mumbai?',
            answer: 'Yes, we can accommodate additional stops for meals, sightseeing, or other breaks during your outstation trip from Mumbai. Simply inform us during the booking process, and we’ll customize the itinerary to fit your preferences.',
          },
          {
            question: 'Is there any extra charge for waiting or detours during outstation trips?',
            answer: 'Any extra charges for waiting time or detours will be communicated to you upfront during the booking process. We ensure full transparency in pricing, so there are no hidden costs.',
          },
          {
            question: 'Why should I choose S9 Travels for my outstation cab service from Mumbai?',
            answer: 'S9 Travels offers reliable, safe, and comfortable outstation cab services from Mumbai. With well-maintained vehicles, professional drivers, and excellent customer service, we ensure a smooth and enjoyable journey to your destination.',
          },
        ]
      ];
      
      const testimonialsData = [
        {
          name: 'Mr. Raghav Joshi',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“I booked an outstation cab from Mumbai to Lonavala with S9 Travels, and the experience was fantastic. The driver was courteous and professional, and the vehicle was clean and comfortable. The journey was smooth and enjoyable. Highly recommend their service for outstation trips!”',
        },
        {
          name: 'Mrs. Shweta Kapoor',
          designation: 'Customer',
          rating: [1, 1, 1, 1, 1],
          text: '“Our outstation trip from Mumbai to Mahabaleshwar with S9 Travels was wonderful. The vehicle was spacious, and the driver was experienced and friendly. The trip was comfortable, and the scenic route was beautiful. We will definitely use S9 Travels again for our future outstation trips.”',
        },
      ];
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8850328441",
            "+91 9552526916",

        ],
        email: "booking@s9travels.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Book Pune To Nashik Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Book Pune To Ganpatipule Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Book Pune To Ratnagiri Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Book Pune To Devkund Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Book Pune To Goa Cab Taxi",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Book Pune To Kolhapur Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Book Pune To Lonavala Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Book Pune To Alibaug Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Book Pune To Aurangabad Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Book Pune To Bhimashankar Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Book Murud Janjira Cab From Pune",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Book Pune To Adlabs Imagica Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Book Pune To Mahabaleshwar Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Book Pune To Trimbakeshwar Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune Mumbai Pune Round Trip",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Mumbai Pune Pickup Drop",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Outstation Cabs From Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service In Pune",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "12 Jyotirlinga Yatra From Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune To Grishneshwar Cab Services",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Pune To Malshej Ghat Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune To Pandharpur Cab Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune To Panhala Fort Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune To Raigad Fort Cab Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune To Satara Kas Pathar Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Pune To Shirdi Cab Pickup Drop",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


   

      
     
      
      
      


    return (
        <div>
        

<section className="page-title centred">
      <div className="bg-layer" style={{ backgroundImage: 'url(/images/background/page-title.jpg)' }}></div>
      <div className="auto-container">
        <div className="content-box">
        
          <h1>{cardData.keyword}</h1>
        </div>
      </div>
    </section>

      

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/78.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                  <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For S9 Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                            <FAQKeyword  faqs={faqData} />

                                                {/* <FAQKeyword faqData={faqData} /> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />
                         

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #252E5B',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#252E5B' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918850328441" className="d-block  text-white">+91 8850328441</a>
                                                <a href="tel:+919552526916" className="d-block  text-white">+91 9552526916</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@s9travels.com" className=" text-white d-block">
                                                    booking@s9travels.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#252E5B' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> S9 Travels <br/>
                                                    Khandesh Nagar, Ghandharva Nagri, Moshi,Pune, pin-412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitooutstationcab;